import posthog from "posthog-js";

const POSTHOG_KEY =
  process.env.REACT_APP_POSTHOG_KEY ||
  "phc_nLO5YOzyWXBWGaHn6CPTAZb5dAYIS2nw5ep15cEoiyx";
const POSTHOG_HOST =
  process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com";

const isLocalhost =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1");

let lastSessionRecordingId: string | null = null;

if (isLocalhost) {
  // Initialize with tracking disabled, but feature flags still work
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
    disable_session_recording: true,
    person_profiles: "identified_only",
  });
} else {
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    capture_pageview: false, // handled manually to align with React Router
    capture_pageleave: true,
    session_recording: {
      maskAllInputs: false,
    },
    person_profiles: "identified_only",
    loaded: (ph) => {
      if (!ph?.onSessionId) return;

      ph.onSessionId((sessionId) => {
        // Delay to allow the recorder to produce a replay URL before capturing.
        setTimeout(() => {
          const sessionURL = ph.get_session_replay_url?.({
            withTimestamp: true,
          });
          if (!sessionURL) return;

          const sessionState =
            (ph as any).sessionManager?.checkAndGetSessionAndWindowId?.(true) ||
            {};
          const currentSessionId = sessionState.sessionId || sessionId;
          if (!currentSessionId) return;
          if (lastSessionRecordingId === currentSessionId) return;

          lastSessionRecordingId = currentSessionId;
          ph.capture("session_recording_ready", {
            sessionURL,
            sessionId: currentSessionId,
            pageURL: window.location.href,
            pageTitle: document.title,
          });
        }, 3000);
      });
    },
  });
}

export default posthog;
